import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import Skeleton from "@mui/material/Skeleton";

import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import moment from "moment-timezone";
import IncidentBox from "../IncidentBox";
import { makeStyles } from "@mui/styles";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import React from "react";
import "./index.css";
export default function ProductCardLoader(props: any) {
  const iconSx = { height: "24px", width: "24px" };
  const productName = {
    postion: "relative",
    top: "-2px",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "24px",
    "@media (max-width: 992px)": {
      fontSize: "15px",
    },
  };
  const card = {
    minHeight: "75px",
    borderRadius: "none",
  };
  const cardBanner = {
    height: "60px",
  };

  const colorCode: any = {
    PO: {
      color: "#D7461F",
      background: "#FEF1E1",
      padding: "0 16px",
    },
    PD: {
      background: "rgba(217, 154, 15, 0.06)",
      color: "#D99A0F",
      padding: "0 16px",
    },
    OP: {
      color: "#00795B",
      backgroundColor: "#E0F5F1",
      padding: "0 16px",
    },
    UM: {
      color: "#2C5CC5",
      backgroundColor: "#F5F8FA",
      background: "#E5F2FD",
      padding: "0 16px",
    },
    MO: {
      color: "#D7461F",
      background: "rgba(215, 70, 31, 0.06)",
      padding: "0 16px",
    },
  };

  // color: colorCode[`${prodColor}`],
  // backgroundColor: colorCode[`${prodColor}`].backgroundColor,
  const cardContent = {
    display: "flex",
    justifyContent: "center",
    padding: "8px 16px 16px 16px",
  };

  const StyledCardActionArea = styled(CardActionArea)(
    () => `
  .MuiCardActionArea-focusHighlight {
      background: transparent;
  }
`
  );
  const useStyles = makeStyles({
    root: {
      boxShadow: "none",
      borderLeft: "1px solid #CFD7DF",
      borderRadius: "0px !imporatant",
      borderBottom:
        props.currentProductIndex === props.totalProducts
          ? "1px solid #CFD7DF"
          : "none",
      borderTop: "1px solid #CFD7DF",
      borderRight: "1px solid #CFD7DF",
      borderTopLeftRadius: props.currentProductIndex === 0 ? "5px" : "0px",
      borderTopRightRadius: props.currentProductIndex === 0 ? "5px" : "0px",
      borderBottomLeftRadius:
        props.currentProductIndex === props.totalProducts ? "5px" : "0px",
      borderBottomRightRadius:
        props.currentProductIndex === props.totalProducts ? "5px" : "0px",
    },
  });
  const classes = useStyles();
  return (
    <Card sx={card} className={classes.root}>
      <StyledCardActionArea>
        <Box
          display="flex"
          sx={cardBanner}
          alignItems="center"
          justifyContent="space-between"
          mx={3}
        >
          <Box display="flex" alignItems="center">
            <Box sx={iconSx} mr={1}>
              <img
                src={`/${props.data.name.toLowerCase()}-dew.svg`}
                height={24}
                width={24}
                alt={props.data.name}
              />
            </Box>
            <Box sx={productName}>{props.data.name}</Box>
          </Box>
          <Box display="flex">
            <Skeleton
              animation="wave"
              variant="rectangular"
              width={120}
              height={30}
              sx={{ bgcolor: "#f2f2f2" }}
            />
          </Box>
        </Box>

        <CardContent
          id={`${props.data.name}-cardContent`}
          className="cardContent"
          sx={cardContent}
        >
          <Skeleton
            animation="wave"
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ bgcolor: "#f2f2f2" }}
          />
        </CardContent>
      </StyledCardActionArea>
    </Card>
  );
}
